var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.booking.is_offer
    ? _c("div", { staticClass: "dashboard-block" }, [
        _c("h2", [_vm._v(_vm._s(_vm.$t("Shortlist Used")))]),
        _vm._v(" "),
        _c("div", { staticClass: "shortlist-backing" }, [
          _vm.bookingHasNoShortlistedTalent
            ? _c("div", { staticClass: "m-t-md text-center" }, [
                _vm._v(
                  "\n      There are no " +
                    _vm._s(_vm.$t("shortlisted stars")) +
                    ".\n    "
                ),
              ])
            : _c(
                "ul",
                {
                  staticClass: "shortlist shortlist-horizontal shortlist-col-4",
                },
                _vm._l(_vm.bookingShortlistedTalent, function (user) {
                  return _c("booking-search-details-list-item", {
                    key: user.id,
                    attrs: { user: user },
                  })
                }),
                1
              ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }